import React from "react";
import "./Footer.css";
const Footer = () => {
  return (
    <div className="anything">
      <h1 className="footer">Footer</h1>
    </div>
  );
};

export default Footer;
